module.exports = __webpack_public_path__ + "img/Arrow_Left_Long.8ea4efe0.svg";